import { ControlsFilters, TabMenus, ViewData, ViewDataTitle } from './components';
import { MessageCircleWarning } from 'lucide-react';
import { LayoutPage } from '@/components/hoc';

const ReportsPage = () => (
	<LayoutPage
		header={{
			description: `Voici les utilisateurs qui ont été signalés.`,
			title: 'Signalements'
		}}
		breadcrumb={{ title: 'Signalements' }}
		icon={MessageCircleWarning}>
		<div className='flex flex-col space-y-3 '>
			<TabMenus />
			<ViewDataTitle />
			<ControlsFilters />
			<ViewData />
		</div>
	</LayoutPage>
);

export default ReportsPage;
